import cx from 'classnames';

/**
 * Bottom spinner that is displayed in the end of the tiles
 * while products are loading
 */
export const BottomSpinner = ({
  hasMoreItems,
  productTotal,
  useGridTiles,
  endOfShopTilesSpinner,
}: {
  hasMoreItems: boolean;
  productTotal: number | null;
  useGridTiles?: boolean;
  endOfShopTilesSpinner: React.RefObject<HTMLDivElement>;
}) => {
  // Show a separate loader for the first page to avoid fetching the next page (which happens when endOfShopTilesSpinner is visible)
  const loadingFirstPage = !hasMoreItems && useGridTiles && typeof productTotal !== 'number';
  return (
    <>
      {loadingFirstPage && (
        <div className="shop-paging-loader">
          <div id="busy-loader" className="busy-loader" />
        </div>
      )}
      <div
        ref={endOfShopTilesSpinner}
        className={cx('shop-paging-loader', { 'is-hidden': !hasMoreItems })}
      >
        <div id="busy-loader" className="busy-loader" />
      </div>
    </>
  );
};
